import React, { useContext } from 'react';

import { ModalHeader } from 'src/components/Modal/ModalHeader';
import { ModalBody } from 'src/components/Modal/ModalBody';
import { ModalFooter } from 'src/components/Modal/ModalFooter';
import { ModalStatic } from 'src/components/Modal/ModalStatic';
import { useBreakpointMatch } from 'src/hooks/useBreakpoint';
import { FilterModalContext } from 'src/components/CategoryListingPage/FilterModalContext';

import classes from './LayeredNav.scss';

type LayeredNavLayoutProps = {
    actions?: React.ReactNode;
    selections: React.ReactNode;
};

export function LayeredNavLayout(props: LayeredNavLayoutProps) {
    const { closeFilter, showFilter } = useContext(FilterModalContext);
    const { isMob, isDesk } = useBreakpointMatch();
    const isOpen = isDesk ? true : showFilter;

    return (
        <ModalStatic onDismiss={closeFilter} isOpen={isOpen} isMob={isMob} className={classes.filter}>
            <ModalHeader title="Filters" onDismiss={closeFilter} className={classes.filterHeader} />
            <ModalBody className={classes.filterBody}>{props.selections}</ModalBody>
            <ModalFooter className={classes.filterFooter}>{props.actions}</ModalFooter>
        </ModalStatic>
    );
}
